import { useEffect, useState } from 'react';
import { changeDisable, custom, customFullModal, getPermission, setMaskDecimal, showMessageError } from '../../../classes/functions';
import './products.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import { AiFillPlusSquare, AiFillDelete } from 'react-icons/ai';
import { FiEdit } from 'react-icons/fi';
import ReactTooltip from "react-tooltip";
import ReactModal from 'react-modal';
import ModalConfirmation from '../../../components/Modal/ModalConfirmation';
import ModalError from '../../../components/Modal/ModalError/index.js';

export default function Products() {

	const { option, id } = useParams();
	const history = useHistory();
	const [view, setView] = useState(false);
	const [carrying, setCarrying] = useState(true);


	const [listUnidades, setListUnidades] = useState([]);
	const [listGrupos, setListGrupos] = useState([]);
	const [listTipoProduto, setListTipoProduto] = useState([]);

	const [unitIndex, setUnitIndex] = useState();
	const [id_cliente, setCliente] = useState('');
	const [descricao, setDescricao] = useState('');
	const [qtde_conf, setQtdeConf] = useState('');
	const [armazem_padrao, setArmazemPadrao] = useState('');
	const [codigo_produto, setCodigoProduto] = useState('');
	const [peso_liquido, setPesoLiquido] = useState(0);
	const [peso_bruto, setPesoBruto] = useState(0);
	const [controla_lote, setControlaLote] = useState('N');
	const [controla_serie, setControlaSerie] = useState('N');
	const [controla_mac, setControlaMac] = useState('N');
	const [controls_pallet, setControlsPallet] = useState('');
	const [id_tipo_produto, setTipoProduto] = useState('');
	const [ativo, setAtivo] = useState('');
	const [ponto_pedido, setPontoPedido] = useState(0);
	const [estoque_seguranca, setEstoqueSeguranca] = useState(0);
	const [lote_economico, setLoteEconomico] = useState(0);
	const [codigos_barra, setCodigosBarra] = useState([]);
	const [codigo_barra, setCodigoBarra] = useState({ unidade_medida: '', quantidade: 0, codigo_barra: '' });
	const [showModals, setShowModals] = useState({
		unitModal: false,
		deleteUnitModal: false,
		errorModal: false
	});

	const [id_grupo, setGrupo] = useState('');
	const [zonas_armazenagem, setZonasArmazenagem] = useState([]);
	const [caracteristicas, setCaracteristicas] = useState([]);
	const [armazem, setArmazem] = useState([]);

	const customTotal = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			width: '500px',
			height: '250px',
			maxHeight: '80%',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
		},
	};

	useEffect(() => {
		async function loadProducts() {
			if (id) {
				getOne(id, option);
			}
		}

		getData();
		loadProducts();

	}, []);

	function validForm() {
		if (!((id_tipo_produto !== '') && (descricao !== '') && (armazem_padrao !== ''))) {
			toast.error('Preencha todos os campos com * antes de salvar.');
			return false;
		}

		let aux_armazem = false;
		armazem.map((element) => {
			if (element.checked === true) {
				aux_armazem = true;
			}
		});

		if (!aux_armazem) {
			toast.error('Preencha todos os campos com * antes de salvar.');
			return false;
		}

		return true;
	}

	function save(e) {
		setCarrying(true);
		e.preventDefault();

		if (!validForm()) {
			setCarrying(false);
			return false;
		}

		codigos_barra.map((codbar) => {
			if (codbar.unidade_medida.ID) {
				codbar.unidade_medida = codbar.unidade_medida.ID;
			}
		});

		const data = {
			row: {
				id_cliente: id_cliente,
				descricao: descricao,
				qtde_conf: qtde_conf,
				id_grupo: id_grupo,
				zonas_armazenagem: zonas_armazenagem,
				armazem: armazem,
				caracteristicas: caracteristicas,
				codigo_produto: codigo_produto,
				codigos_barra: codigos_barra,
				id_tipo_produto: id_tipo_produto,
				ponto_pedido: ponto_pedido,
				lote_economico: lote_economico,
				controls_pallet: controls_pallet,
				estoque_seguranca: estoque_seguranca,
				peso_liquido: peso_liquido,
				peso_bruto: peso_bruto,
				controla_lote: controla_lote,
				controla_serie: controla_serie,
				controla_mac: controla_mac,
				ativo: ativo,
				armazem_padrao: armazem_padrao
			}
		}

		for (const index in data.row) {
			if (!data.row[index]) {
				delete data.row[index];
			}
		}

		if (id) {
			data.row.id = id;
			api.put("/api/products/put", data)
				.then(() => {
					toast.success('Registro atualizado com sucesso.');
					history.push('/products');
				}
				).catch((error) => {
					console.log(error);
					showMessageError(error.response.data);
					setCarrying(false);
				});
		} else {
			api.post("/api/products/post", data)
				.then(() => {
					toast.success('Registro inserido com sucesso.');
					history.push('/products');
				}
				).catch((error) => {
					showMessageError(error.response.data);
					setCarrying(false);
				});
		}
	}

	function getOne(id, option) {
		api.get("/api/products/getList?id=" + id)
			.then((response) => {
				setCliente(response.data.row.id_cliente);
				setDescricao(response.data.row.descricao);
				setQtdeConf(response.data.row.qtde_conf);
				setGrupo(response.data.row.id_grupo);
				setZonasArmazenagem(response.data.row.zonas_armazenagem);
				setCaracteristicas(response.data.row.caracteristicas);
				setArmazem(response.data.row.armazem);
				setPontoPedido(response.data.row.ponto_pedido);
				setLoteEconomico(response.data.row.lote_economico);
				setEstoqueSeguranca(response.data.row.estoque_seguranca);
				setArmazemPadrao(response.data.row.armazem_padrao);
				setCodigoProduto(response.data.row.codigo_produto);
				setTipoProduto(response.data.row.id_tipo_produto);
				setPesoLiquido(response.data.row.peso_liquido);
				setPesoBruto(response.data.row.peso_bruto);
				setControlaLote(response.data.row.controla_lote);
				setControlaSerie(response.data.row.controla_serie);
				setControlaMac(response.data.row.controla_mac);
				setControlsPallet(response.data.row.controls_pallet);
				setAtivo(response.data.row.ativo);
				setCodigosBarra(response.data.row.codigos_barra);
				setCarrying(false);
			}
			).catch((error) => {
				console.log(error);
				showMessageError(error.response.data);
				setCarrying(false);
			});

		setView(changeDisable(option));
	}

	function cancel() {
		history.push('/products');
	}

	function remove() {
		api.delete("/api/products/delete?id=" + id)
			.then(() => {
				toast.success('Registro excluído com sucesso.');
				history.push('/products');
			}
			).catch((error) => {
				showMessageError(error.response.data);
			});
	}

	function getData() {
		api.get("/api/products/getDataPage")
			.then((response) => {
				setListUnidades(response.data.unidades);
				setListGrupos(response.data.grupos);
				setListTipoProduto(response.data.tipos)

				if (!id) {
					setZonasArmazenagem(response.data.zonas);
					setArmazem(response.data.armazem);
					response.data.caracteristicas.map((element) => {
						if (element.active_link === 'S') {
							element.checked = true;
						}

					});
					setCaracteristicas(response.data.caracteristicas);
				}
				setCarrying(false);
			}).catch((error) => {
				showMessageError(error.response.data);
				setCarrying(false);
			});
	}

	function verifyBarcode(barcode) {
		api
			.get(`/api/barcodes/${barcode}`)
			.then((response) => {
				if (response.data.codigo_produto) {
					toast.error(`O código de barras inserido já está cadastrado no produto ${response.data.codigo_produto}.`);

					return false;
				}
			})
			.catch((error) => {
				let barcodeExists = false;

				if (error?.response?.data?.message !== "Codigo de barra não encontrado") {
					toast.error(error?.response?.data?.message);
				}

				codigos_barra.map((barcode) => {
					if (barcode.codigo_barra === codigo_barra.codigo_barra && !barcode.deleted) {
						barcodeExists = true;
					}
				});

				if (!barcodeExists) {
					setShowModals((prevState) => ({ ...prevState, unitModal: false }));

					if (unitIndex >= 0) {
						codigos_barra.filter((codigo_barra, subIndex) => unitIndex === subIndex)[0] = codigo_barra;

						setCodigosBarra(codigos_barra.map((codbar, subIndex) => {
							if (unitIndex === subIndex) {
								codbar = codigo_barra;
							}

							return codbar;
						}));

						setUnitIndex();
						return setCodigoBarra({ unidade_medida: '', quantidade: 0, codigo_barra: '' });
					}

					return setCodigosBarra([...codigos_barra, codigo_barra]);
				}

				return toast.error("Este código de barras já existe.");
			});
	}

	function changeZone(e) {
		let aux_zone = [];

		zonas_armazenagem.forEach((element) => {
			if (parseInt(element.id) === parseInt(e.target.value)) {
				element.checked = !element.checked;
			}

			aux_zone.push(element);
		});

		setZonasArmazenagem(aux_zone);
	}

	function changeWarehouse(e) {
		let aux_warehouses = [];

		armazem.forEach((element) => {
			if (element.id === e.target.value) {
				element.checked = !element.checked;
			}

			aux_warehouses.push(element);
		});

		setArmazem(aux_warehouses);
	}

	function changeFeatures(e) {
		let aux_caracteristicas = [];

		caracteristicas.forEach((element) => {
			if (element.chave === e.target.value) {
				element.checked = !element.checked;
			}

			aux_caracteristicas.push(element);
		});

		setCaracteristicas(aux_caracteristicas);
	}

	function modifyBarcode(property, value, index) {
		setCodigosBarra(codigos_barra?.map((codigo_barra, subIndex) => {
			if (subIndex === index) {
				codigo_barra[property] = value;
			}

			return codigo_barra;
		}));
	}

	function verifyUnitModalValues() {
		if (codigo_barra.codigo_barra && codigo_barra.unidade_medida) {
			if (codigo_barra.quantidade === 0) {
				return toast.error('A quantidade deve ser maior que 0.');
			}

			verifyBarcode(codigo_barra.codigo_barra);

			return setCodigoBarra({ unidade_medida: '', quantidade: 0, codigo_barra: '' });
		}

		return toast.error('Por favor, preencha todos os campos para realizar o cadastro.');
	}

	function deleteFromArray() {
		setUnitIndex(unitIndex);
		setCodigosBarra(codigos_barra.map((codbar) => {
			if (codbar.codigo_barra === codigo_barra.codigo_barra) {
				codbar.deleted = "*";
			}

			return codbar;
		}));

		return codigos_barra;
	}

	useEffect(() => {
		if (!showModals.unitModal) {
			setCodigoBarra({ unidade_medida: '', quantidade: 0, codigo_barra: '' });
		}
	}, [showModals.unitModal]);

	return (
		<div>
			<Header />
			<Division />
			<Lateral />
			<ReactTooltip />
			<ReactModal
				isOpen={showModals.unitModal}
				onRequestClose={() => setShowModals((prevState) => ({ ...prevState, unitModal: false }))}
				style={custom("50%", "auto")}
			>
				<div className="unitModal">
					<h1 className="unitModal___title">Unidade de Medida</h1>
					<div className="formDiv barcode__div">
						<label>Unidade de Medida&nbsp;<label className="required">*</label></label>
						<select value={codigo_barra?.unidade_medida?.ID || codigo_barra?.unidade_medida} onChange={(e) => setCodigoBarra((prevState) => ({ ...prevState, unidade_medida: e.target.value }))}>
							<option value="">Selecione</option>
							{listUnidades?.map((item, index) => {
								return (
									<>
										<option key={index} value={item?.id}>{item?.descricao}</option>
										{!listUnidades.includes(codigo_barra?.codigo_barra?.unidade_medida?.ID?.toString()) && listUnidades.length === index + 1 && (
											<option value={codigo_barra?.unidade_medida?.ID}>{codigo_barra?.unidade_medida?.DESCRICAO}</option>
										)}
									</>
								)
							})}
						</select>
					</div>

					<div className="formDiv barcode__div">
						<label>Qtde de Embalagem&nbsp;<label className="required">*</label></label><br />
						<input type="text" value={codigo_barra?.quantidade} onChange={(e) => setCodigoBarra((prevState) => ({ ...prevState, quantidade: e.target.value }))} placeholder="Qtde de Embalagem" maxLength="6" />
					</div>

					<div className="formDiv barcode__div">
						<label>Código de Barras&nbsp;<label className="required">*</label></label><br />
						<input type="text" value={codigo_barra?.codigo_barra} onChange={(e) => setCodigoBarra((prevState) => ({ ...prevState, codigo_barra: e.target.value }))} placeholder="Código de Barras" maxLength="15" />
					</div>

					<div className="unitModal___buttons">
						<button className="unitModal____button" onClick={() => setShowModals((prevState) => ({ ...prevState, unitModal: false }))}>Fechar</button>
						<button className="unitModal____button" onClick={verifyUnitModalValues}>Adicionar</button>
					</div>
				</div>
			</ReactModal>
			<ModalConfirmation state={showModals?.deleteUnitModal} setState={setShowModals} stateName={'deleteUnitModal'} custom={customTotal} param={unitIndex} action={deleteFromArray} title={'Deseja realmente excluir este item'} />

			{carrying && <div className="content">
				<div className="divCarrying">
					<span>Carregando..</span>
					<FaCog icon="spinner" className="spinner" />
				</div>
			</div>}
			{!carrying && <div className="content">
				<Title name="Cadastro de Produtos">
					<Link to="/products">
						<FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
					</Link>
				</Title>
				<div className="container">
					<form className="form-profile customers">
						<div className="containerGroupData">
							<h2>Dados Cadastrais</h2>
							<hr></hr>

							<div className="divGroup">
								<div className="formDiv">
									<label>Código</label><br />
									<input type="text" placeholder="Descrição" value={codigo_produto}
										onChange={(e) => setCodigoProduto(e.target.value)} maxLength="20"
										disabled={view} />
								</div>
								<div className="formDiv">
									<label>Descrição</label>&nbsp;<label className="required">*</label><br />
									<input type="text" placeholder="Descrição" value={descricao}
										onChange={(e) => setDescricao(e.target.value)} maxLength="250"
										disabled={view} />
								</div>

								<div className="formDiv">
									<label>Tipos de Produtos</label>&nbsp;<label className="required">*</label><br />
									<select value={id_tipo_produto} onChange={(e) => setTipoProduto(e.target.value)}
										disabled={view}>
										<option value="">Selecione</option>
										{listTipoProduto.map((item, index) => (
											<option key={index} value={item.id}>{item.descricao}</option>
										))}
									</select>
								</div>

								<div className="formDiv">
									<label>Grupo de Produtos</label><br />
									<select value={id_grupo} onChange={(e) => setGrupo(e.target.value)} disabled={view}>
										<option value="">Selecione</option>
										{listGrupos.map((item, index) => (
											<option key={index} value={item.id}>{item.descricao}</option>
										))}
									</select>
								</div>
							</div>

							<div className="divGroup">
								<div className="formDiv">
									<label>Armazém Padrão</label>&nbsp;<label className="required">*</label><br />
									<select value={armazem_padrao} onChange={(e) => setArmazemPadrao(e.target.value)}
										disabled={view}>
										<option value="">Selecione</option>
										{armazem.map((item, index) => (
											<option key={index} value={item.id}>{item.descricao}</option>
										))}
									</select>
								</div>

								<div className="formDiv">
									<label>Ativo</label><br />
									<select value={ativo} onChange={(e) => setAtivo(e.target.value)} disabled={view}>
										<option>Selecione</option>
										<option value="S">Sim</option>
										<option value="N">Não</option>
									</select>
								</div>

								<div className="formDiv">
									<label>Ponto de Pedido</label><br />
									<input type="text" placeholder="Ponto de Pedido" value={ponto_pedido}
										onChange={(e) => setPontoPedido(setMaskDecimal(e.target.value, 2))}
										maxLength="11" disabled={view} />
								</div>
								<div className="formDiv">
									<label>Estoque Segurança</label><br />
									<input type="number" placeholder="Estoque Segurança" value={estoque_seguranca}
										onChange={(e) => setEstoqueSeguranca(e.target.value)}
										maxLength="11" disabled={view} />
								</div>

								<div className="formDiv">
									<label>Lote Econômico</label><br />
									<input type="number" placeholder="Lote Econômico" value={lote_economico}
										onChange={(e) => setLoteEconomico(e.target.value)}
										maxLength="11" disabled={view} />
								</div>
							</div>

							<div className="divGroup">
								<div className="formDiv">
									<label>Qtde Conferência</label><br />
									<input type="text" placeholder="Qtde Conferência" value={qtde_conf}
										onChange={(e) => setQtdeConf(setMaskDecimal(e.target.value, 4))}
										maxLength="11" disabled={view} />
								</div>
								<div className="formDiv">
									<label>Peso Líquido (kg)</label><br />
									<input type="text" placeholder="Peso Líquido (kg)" value={peso_liquido}
										onChange={(e) => setPesoLiquido(setMaskDecimal(e.target.value, 3))}
										maxLength="11" disabled={view} />
								</div>

								<div className="formDiv">
									<label>Peso Bruto (kg)</label><br />
									<input type="text" placeholder="Peso Bruto (kg)" value={peso_bruto}
										onChange={(e) => setPesoBruto(setMaskDecimal(e.target.value, 3))}
										maxLength="11" disabled={view} />
								</div>
							</div>

							<div className="divGroup">
								<div className="formDiv">
									<label>Controla Lote</label><br />
									<select value={controla_lote} onChange={(e) => setControlaLote(e.target.value)}
										disabled={view}>
										<option>Selecione</option>
										<option value="S">Sim</option>
										<option value="N">Não</option>
									</select>
								</div>

								<div className="formDiv">
									<label>Controla Série</label><br />
									<select value={controla_serie} onChange={(e) => setControlaSerie(e.target.value)}
										disabled={view}>
										<option>Selecione</option>
										<option value="S">Sim</option>
										<option value="N">Não</option>
									</select>
								</div>

								<div className="formDiv">
									<label>Controla MAC</label><br />
									<select value={controla_mac} onChange={(e) => setControlaMac(e.target.value)}
										disabled={view}>
										<option>Selecione</option>
										<option value="S">Sim</option>
										<option value="N">Não</option>
									</select>
								</div>

								<div className="formDiv">
									<label>Controla Palete</label><br />
									<select value={controls_pallet} onChange={(e) => setControlsPallet(e.target.value)} disabled={view}>
										<option>Selecione</option>
										<option value="S">Sim</option>
										<option value="N">Não</option>
									</select>
								</div>
							</div>
						</div>
						<div className='containerGroupData' style={{ marginTop: '0.5rem' }}>
							<div className='units'>
								<button type='button' className='units__button'>
									<AiFillPlusSquare className='units___icon' onClick={() => setShowModals((prevState) => ({ ...prevState, unitModal: true }))} />
								</button>
								<h2 className='unit__title'>Unidade de Medida</h2>
							</div>
							{codigos_barra?.map((codigo_barra, index) => {
								if (!codigo_barra.deleted) {
									let currentCodbar = (prevState) => {
										return ({ ...prevState, id: codigo_barra.id, codigo_barra: codigo_barra.codigo_barra, quantidade: codigo_barra.quantidade, unidade_medida: codigo_barra.unidade_medida })
									}
									return (
										<div className='divGroup barcode'>
											<div className="formDiv barcode__div">
												<label>Unidade de Medida</label>
												<select value={codigo_barra?.unidade_medida.ID || codigo_barra?.unidade_medida} onChange={(e) => modifyBarcode('unidade_medida', e.target.value, index)} disabled>
													{listUnidades?.map((item, index) => {
														return (
															<>
																<option key={index} value={item?.id}>{item?.descricao}</option>
																{!listUnidades.includes(codigo_barra?.codigo_barra?.unidade_medida?.ID?.toString()) && listUnidades.length === index + 1 && (
																	<option value={codigo_barra?.unidade_medida?.ID}>{codigo_barra?.unidade_medida?.DESCRICAO}</option>
																)}
															</>
														)
													})}
												</select>
											</div>

											<div className="formDiv barcode__div">
												<label>Qtde de Embalagem</label><br />
												<input type="text" placeholder="Qtde de Embalagem" value={codigo_barra?.quantidade} maxLength="6" disabled />
											</div>

											<div className="formDiv barcode__div">
												<label>Código de Barras</label><br />
												<input type="text" placeholder="Código de Barras" value={codigo_barra?.codigo_barra} maxLength="15" disabled />
											</div>

											<div className="formDiv barcode__div" id="barcode__div-icon">
												<AiFillDelete className="barcode___icon" onClick={() => { setUnitIndex(index); setCodigoBarra((prevState) => currentCodbar(prevState)); setShowModals((prevState) => ({ ...prevState, deleteUnitModal: true })) }} />
												<FiEdit className="barcode___icon" onClick={() => { setUnitIndex(index); setCodigoBarra((prevState) => currentCodbar(prevState)); setShowModals((prevState) => ({ ...prevState, unitModal: true })) }} />
											</div>
										</div>
									)
								}
							})}
						</div>
						<div className="divGroup">
							<div className="formDivList">
								<div className="containerGroupData">
									<h2>Zonas de Armazenagem&nbsp;<label className="required">*</label></h2>
									<hr></hr>

									<table>
										<thead>
											<tr>
												<th scope="col" className="column">#</th>
												<th scope="col">Descrição</th>
											</tr>
										</thead>
										<tbody>
											{zonas_armazenagem.map((item, index) => {
												return (
													<tr key={index}>
														<td data-label="#">
															<input type="checkbox" checked={item.checked} value={item.id} onChange={changeZone} />
														</td>
														<td data-label="Descrição">{item.descricao}</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>
							</div>

							<div className="formDivListRight">
								<div className="containerGroupData">
									<h2>Armazéns&nbsp;<label className="required">*</label></h2>
									<hr></hr>

									<table>
										<thead>
											<tr>
												<th scope="col" className="column">#</th>
												<th scope="col">Descrição</th>
											</tr>
										</thead>
										<tbody>
											{armazem.map((item, index) => {
												return (
													<tr key={index}>
														<td data-label="#">
															<input type="checkbox" checked={item.checked} value={item.id} onChange={changeWarehouse} />
														</td>
														<td data-label="Descrição">{item.descricao}</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>
							</div>
						</div>
						{caracteristicas.length > 0 && <div className="divGroup">
							<div className="formDivList">
								<div className="containerGroupData">
									<h2>Características</h2>
									<hr></hr>

									<table>
										<thead>
											<tr>
												<th scope="col" className="column">#</th>
												<th scope="col">Descrição</th>
											</tr>
										</thead>
										<tbody>
											{caracteristicas.map((item, index) => {
												return (
													<tr key={index}>
														<td data-label="#">
															<input type="checkbox" checked={item.checked} value={item.chave} onChange={changeFeatures} />
														</td>
														<td data-label="Descricao">{item.descricao}</td>
													</tr>
												)
											})}
										</tbody>
									</table>
								</div>
							</div>
							<div className="formDivListRight"></div>
						</div>}
						{!view && <div className="formDiv">
							{getPermission('CADASTROS - PRODUTOS - CADASTRO') &&
								<button type="submit" className="buttonSubmit" onClick={save}
									disabled={view}>Salvar</button>}
							<button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar
							</button>
							{id && getPermission('CADASTROS - PRODUTOS - EXCLUSAO') &&
								<button type="button" className="buttonRemove" onClick={remove}
									disabled={view}>Excluir</button>}
						</div>}
					</form>
				</div>
			</div>}
		</div>
	)
}